function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype), d = Object.defineProperty;
    return d(g, "next", {
        value: verb(0)
    }), d(g, "throw", {
        value: verb(1)
    }), d(g, "return", {
        value: verb(2)
    }), typeof Symbol === "function" && d(g, Symbol.iterator, {
        value: function() {
            return this;
        }
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { Message } from '@wegic/ui';
import { useCallback, useState } from 'react';
import { clearRegisterTrackingCookies, setRegisterTrackingCookies } from '@/services/auth';
import { createUserRequest } from '@/services/request';
import { buildAuthParamsWithAnonymous } from '@/utils';
function isCodeResponse(res) {
    return !!res && 'code' in res;
}
function mapGoogleLoginResToUser(data) {
    var _data_hasPassword, _data_createDate;
    return {
        unionId: data.unionId,
        userId: data.userId,
        userImage: data.userImage,
        userName: data.userName,
        email: data.email,
        inviteCode: data.inviteCode,
        countryBlock: data.countryBlock,
        freeRightBlock: data.freeRightBlock,
        loginType: data.loginType,
        hasPassword: (_data_hasPassword = data.hasPassword) !== null && _data_hasPassword !== void 0 ? _data_hasPassword : false,
        createDate: (_data_createDate = data.createDate) !== null && _data_createDate !== void 0 ? _data_createDate : ''
    };
}
function getCurrentUserOrFallback(userRequest, fallbackUser) {
    return _async_to_generator(function() {
        var userInfoRes;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        userRequest.get('/accounts').catch(function() {
                            return null;
                        })
                    ];
                case 1:
                    userInfoRes = _state.sent();
                    return [
                        2,
                        (userInfoRes === null || userInfoRes === void 0 ? void 0 : userInfoRes.data) || fallbackUser
                    ];
            }
        });
    })();
}
/**
 * Google 登录 Hook
 */ export function useGoogleAuth(config) {
    var _ref = config || {}, apiConfig = _ref.apiConfig, getAnonymousId = _ref.getAnonymousId, onEvent = _ref.onEvent;
    var _useState = _sliced_to_array(useState(false), 2), loading = _useState[0], setLoading = _useState[1];
    var _useState1 = _sliced_to_array(useState(null), 2), error = _useState1[0], setError = _useState1[1];
    var userRequest = createUserRequest(apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.baseURL);
    var handleGoogleLogin = useCallback(function(response) {
        return _async_to_generator(function() {
            var _setRegisterTrackingCookies, imRef, irpid, loginRes, firstRegister, fallbackUser, user, err, errorMessage;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!isCodeResponse(response)) {
                            return [
                                2,
                                {
                                    success: false
                                }
                            ];
                        }
                        setLoading(true);
                        setError(null);
                        _setRegisterTrackingCookies = setRegisterTrackingCookies(), imRef = _setRegisterTrackingCookies.imRef, irpid = _setRegisterTrackingCookies.irpid;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            8,
                            9
                        ]);
                        return [
                            4,
                            userRequest.post('/accounts/google/login', buildAuthParamsWithAnonymous({
                                credential: response.code
                            }, getAnonymousId))
                        ];
                    case 2:
                        loginRes = _state.sent();
                        firstRegister = (loginRes.data || {}).firstRegister;
                        if (!(loginRes.code === 0)) return [
                            3,
                            5
                        ];
                        Message.success(intl.get('Login_Success_Message'));
                        fallbackUser = mapGoogleLoginResToUser(loginRes.data);
                        return [
                            4,
                            getCurrentUserOrFallback(userRequest, fallbackUser)
                        ];
                    case 3:
                        user = _state.sent();
                        return [
                            4,
                            onEvent === null || onEvent === void 0 ? void 0 : onEvent({
                                type: 'login:google:success',
                                data: user,
                                isFirstRegister: !!firstRegister
                            })
                        ];
                    case 4:
                        _state.sent();
                        setLoading(false);
                        return [
                            2,
                            {
                                success: true,
                                user: user,
                                isFirstRegister: !!firstRegister
                            }
                        ];
                    case 5:
                        Message.error(loginRes.message);
                        setLoading(false);
                        return [
                            2,
                            {
                                success: false
                            }
                        ];
                    case 6:
                        return [
                            3,
                            9
                        ];
                    case 7:
                        err = _state.sent();
                        errorMessage = (err === null || err === void 0 ? void 0 : err.message) || intl.get('Login_Failed_Message');
                        setError(errorMessage);
                        onEvent === null || onEvent === void 0 ? void 0 : onEvent({
                            type: 'error',
                            error: {
                                message: errorMessage,
                                type: 'auth'
                            },
                            source: 'google-login'
                        });
                        setLoading(false);
                        return [
                            2,
                            {
                                success: false,
                                error: errorMessage
                            }
                        ];
                    case 8:
                        clearRegisterTrackingCookies(imRef, irpid);
                        return [
                            7
                        ];
                    case 9:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.baseURL,
        getAnonymousId,
        onEvent
    ]);
    return {
        handleGoogleLogin: handleGoogleLogin,
        loading: loading,
        error: error
    };
}
